(function () {
  // Intercepts the real /cart/add|change|update|clear fetch calls rather than relying on the
  // theme's shopify:cart:lines-update event (confirmed via direct instrumentation that event does
  // not reliably fire on a real Add click).
  //
  // 2026-09-23: the card always advertises the FIXED partner product (whatever this page's
  // custom.cross_sell_product metafield points to) -- never the current page's own product, even
  // when the current page's own product is the one actually sitting in the cart. There is no
  // "self" card anymore; that was a misread of the requirement ("on the baby bum page, baby butter
  // should show in the card" -- always, regardless of which specific item triggered it).
  function cartUrl() {
    var base = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
    return base + '.json';
  }
  function quantityFor(cart, productId) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (String(item.product_id) === String(productId)) total += item.quantity;
    });
    return total;
  }
  function applyState(root, cart) {
    var pairProductId = root.dataset.crossSellProductId;
    if (!pairProductId) return;
    var badges = root.querySelector('[data-mt-trust-badges]');
    var pairCard = root.querySelector('[data-mt-cross-sell="pair"]');
    var activatedCard = root.querySelector('[data-mt-cross-sell="activated"]');
    if (!badges) return;
    var pQty = quantityFor(cart, root.dataset.productId);
    var xQty = quantityFor(cart, pairProductId);
    var combinedQty = pQty + xQty;
    var showActivated = combinedQty >= 2;
    var showPair = !showActivated && combinedQty >= 1;
    var showAnyCrossSell = showPair || showActivated;
    badges.hidden = showAnyCrossSell;
    if (pairCard) pairCard.hidden = !showPair;
    if (activatedCard) activatedCard.hidden = !showActivated;
    var paymentPromise = document.querySelector('[data-mt-payment-promise]');
    if (paymentPromise) paymentPromise.hidden = showAnyCrossSell;
  }
  function idsQty(cart, ids) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (ids.indexOf(String(item.product_id)) !== -1) total += item.quantity;
    });
    return total;
  }
  // CLAYDEO: hair clay in cart = 30% off deodorants. Clay pages advertise until a deodorant is in the
  // cart; deodorant pages only confirm, and only once clay is in the cart.
  function applyClayDeo(cart) {
    Array.prototype.slice.call(document.querySelectorAll('[data-mt-claydeo]')).forEach(function (el) {
      var clay = idsQty(cart, (el.dataset.clayIds || '').split(','));
      var deo = idsQty(cart, (el.dataset.deoIds || '').split(','));
      var offer = el.querySelector('[data-mt-claydeo-card="offer"]');
      var active = el.querySelector('[data-mt-claydeo-card="activated"]');
      var showActive = clay > 0 && deo > 0;
      var showOffer = el.dataset.role === 'clay' && clay > 0 && deo === 0;
      if (offer) offer.hidden = !showOffer && !offer.hasAttribute('data-force-show');
      if (active) active.hidden = !showActive;
    });
  }
  // Scent dropdown on the CLAYDEO card: swap the photo and prices to match the chosen scent.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.hasAttribute || !sel.hasAttribute('data-cdeo-select')) return;
    var card = sel.closest('[data-mt-claydeo-card]');
    var opt = sel.options[sel.selectedIndex];
    if (!card || !opt) return;
    var img = card.querySelector('[data-cdeo-img]');
    var was = card.querySelector('[data-cdeo-was]');
    var now = card.querySelector('[data-cdeo-now]');
    if (img && opt.dataset.img) img.src = opt.dataset.img;
    if (was) was.textContent = opt.dataset.price;
    if (now) now.textContent = opt.dataset.sale;
  });
  function getRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mt-cross-sell-toggle]'));
  }
  function refresh() {
    var roots = getRoots();
    var hasClayDeo = document.querySelector('[data-mt-claydeo]');
    if (!roots.length && !hasClayDeo) return;
    fetch(cartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) { roots.forEach(function (root) { applyState(root, cart); }); applyClayDeo(cart); })
      .catch(function (err) { console.error('[mt-cross-sell]', err); });
  }

  if (!window.__mtCrossSellFetchPatched) {
    window.__mtCrossSellFetchPatched = true;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var request = originalFetch.apply(this, arguments);
      var url = '';
      try { url = arguments[0] && arguments[0].toString ? arguments[0].toString() : ''; } catch (e) {}
      if (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      ) {
        request.then(function () { setTimeout(refresh, 400); }).catch(function () {});
      }
      return request;
    };
  }

  function init() {
    if (!getRoots().length && !document.querySelector('[data-mt-claydeo]')) return;
    refresh();
    document.addEventListener('shopify:cart:lines-update', refresh);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
